import * as DashboardConstants from '../Dashboards/DashboardConstants'

export const OfflineHeaders = [
    {
        key: 'incidentNo',
        header: DashboardConstants.IncidentNo,
        hidden: true,
        optional: true
    },
    {
        key: 'assigned_to',
        header: DashboardConstants.AssignedTo,
        hidden: true,
        optional: true
    },
    {
        key: 'incidentStatus',
        header: DashboardConstants.IncidentStatus,
        hidden: true,
        optional: true
    },
    {
        key: 'resourceName',
        header: DashboardConstants.ResourceName,
        hidden: false,
        optional: false
    },
    {
        key: 'resourcePoolName',
        header: DashboardConstants.ResourcePoolName,
        hidden: false,
        optional: false
    },
    {
        key: 'resourceStatus',
        header: DashboardConstants.ResourceStatus,
        hidden: false,
        optional: false
    },
    {
        key: 'recentCurrentActiveProcess',
        header: DashboardConstants.RecentCurrentActiveProcess,
        hidden: false,
        optional: false
    },
    {
        key: 'timeSpaceSinceRecentExecution',
        header: DashboardConstants.TimeSpanSinceRecentExecution,
        hidden: false,
        optional: false
    },
    {
        key: 'numberOfSimilarIssues',
        header: DashboardConstants.NoOfSimilarIssues,
        hidden: true,
        optional: true
    },
    {
        key: 'lastStatusChanged',
        header: DashboardConstants.LastStatusChange,
        hidden: false,
        optional: false
    },
    {
        key: 'client',
        header: DashboardConstants.Client,
        hidden: false,
        optional: false
    }
]

export const busyHeaders = [
    {
        key: 'resourceName',
        header: DashboardConstants.ResourceName,
        hidden: false,
        optional: false
    },
    {
        key: 'recentCurrentActiveProcess',
        header: DashboardConstants.RecentCurrentActiveProcess,
        hidden: false,
        optional: false
    },
    {
        key: 'timeSpaceSinceRecentExecution',
        header: DashboardConstants.TimeSpanSinceRecentExecution,
        hidden: true,
        optional: true
    },
    {
        key: 'lastStatusChanged',
        header: DashboardConstants.LastStatusChange,
        hidden: false,
        optional: false
    },
    {
        key: 'client',
        header: DashboardConstants.Client,
        hidden: false,
        optional: false
    }
]



export const OfflineMockData = [
    {
        id: 0,
        incidentNo: 'INC1845266',
        assigned_to: 'Akhila R',
        incident_status: 'New',
        resourceName: 'Lenovo001',
        resourcepoolName: 'Order to cash pool',
        recentActiveProcess: 'Order to cash process',
        timeSpan: '00:30',
        similarissues: '14',
        statusChange: "1/12/2021 8:31:31 AM",
        client: "CIBC"
    },
    {
        id: 1,
        incidentNo: "INC1845265",
        assigned_to: 'Manish D',
        incident_status: 'Resolved',
        resourceName: 'Lenovo001',
        resourcepoolName: 'Password Reset Pool',
        recentActiveProcess: 'Order to cash process',
        timeSpan: '00:30',
        similarissues: '14',
        statusChange: "1/12/2021 8:31:31 AM",
        client: "CIBC"
    }
]
export const Data =
{
    offline: [{
        incidentNo: 'INC1856382',
        incidentUrl: 'https://ibmgbsindia1prod.service-now.com/incident.do?sys_id=34b05ce01bf78510aed47df4464bcbf8',
        incidentStatus: 'New',
        resourceName: 'Lenovo001',
        resourcePoolName: 'Order to Cash Pool',
        recentCurrentActiveProcess: 'Order to Cash Process',
        timeSpaceSinceRecentExecution: '00:30',
        numberOfSimilarIssues: 14,
        lastStatusChanged: '1/12/2022 8:31:31 AM',
        client: 'CIBC',
        resourceStatus: 'Offline'
    },
    {
        incidentNo: 'INC1857812',
        incidentUrl: 'https://ibmgbsindia1prod.service-now.com/incident.do?sys_id=34b05ce01bf78510aed47df4464bcbf8',
        assignedTo: 'Sameer Herkal',
        incidentStatus: 'New',
        resourceName: 'Lenovo007',
        resourcePoolName: 'Password Reset Pool',
        recentCurrentActiveProcess: 'Password Reset Process',
        timeSpaceSinceRecentExecution: '02:05',
        numberOfSimilarIssues: 9,
        lastStatusChanged: '1/12/2022 8:31:31 AM',
        client: 'CIBC',
        resourceStatus: 'Offline'
    }
    ],
    missing: [{
        incidentNo: 'INC1856382',
        incidentUrl: 'https://ibmgbsindia1prod.service-now.com/incident.do?sys_id=34b05ce01bf78510aed47df4464bcbf8',
        incidentStatus: 'New',
        resourceName: 'Lenovo001',
        resourcePoolName: 'Order to Cash Pool',
        recentCurrentActiveProcess: 'Order to Cash Process',
        timeSpaceSinceRecentExecution: '00:30',
        numberOfSimilarIssues: 14,
        lastStatusChanged: '1/12/2022 8:31:31 AM',
        client: 'CIBC',
        resourceStatus: 'missing'
    },
    {
        incidentNo: 'INC1857812',
        incidentUrl: 'https://ibmgbsindia1prod.service-now.com/incident.do?sys_id=34b05ce01bf78510aed47df4464bcbf8',
        assignedTo: 'Sameer Herkal',
        incidentStatus: 'New',
        resourceName: 'Lenovo007',
        resourcePoolName: 'Password Reset Pool',
        recentCurrentActiveProcess: 'Password Reset Process',
        timeSpaceSinceRecentExecution: '02:05',
        numberOfSimilarIssues: 9,
        lastStatusChanged: '1/12/2022 8:31:31 AM',
        client: 'CIBC',
        resourceStatus: 'missing',
    }
    ],
    loggedOut: [{
        incidentNo: 'INC1856382',
        incidentUrl: 'https://ibmgbsindia1prod.service-now.com/incident.do?sys_id=34b05ce01bf78510aed47df4464bcbf8',
        incidentStatus: 'New',
        resourceName: 'Lenovo001',
        resourcePoolName: 'Order to Cash Pool',
        recentCurrentActiveProcess: 'Order to Cash Process',
        timeSpaceSinceRecentExecution: '00:30',
        numberOfSimilarIssues: 14,
        lastStatusChanged: '1/12/2022 8:31:31 AM',
        client: 'CIBC',
        resourceStatus: 'loggedOut'
    },
    {
        incidentNo: 'INC1857812',
        incidentUrl: 'https://ibmgbsindia1prod.service-now.com/incident.do?sys_id=34b05ce01bf78510aed47df4464bcbf8',
        assignedTo: 'Sameer Herkal',
        incidentStatus: 'New',
        resourceName: 'Lenovo007',
        resourcePoolName: 'Password Reset Pool',
        recentCurrentActiveProcess: 'Password Reset Process',
        timeSpaceSinceRecentExecution: '02:05',
        numberOfSimilarIssues: 9,
        lastStatusChanged: '1/12/2022 8:31:31 AM',
        client: 'CIBC',
        resourceStatus: 'loggedOut'
    }],
    available: [{
        incidentNo: 'INC1856382',
        incidentUrl: 'https://ibmgbsindia1prod.service-now.com/incident.do?sys_id=34b05ce01bf78510aed47df4464bcbf8',
        incidentStatus: 'Resolved',
        resourceName: 'Lenovo001',
        resourcePoolName: 'Order to Cash Pool',
        recentCurrentActiveProcess: 'Order to Cash Process',
        timeSpaceSinceRecentExecution: '00:30',
        numberOfSimilarIssues: 14,
        lastStatusChanged: '1/12/2022 8:31:31 AM',
        client: 'CIBC',
        resourceStatus: 'available'
    },
    {
        incidentNo: 'INC1857812',
        incidentUrl: 'https://ibmgbsindia1prod.service-now.com/incident.do?sys_id=34b05ce01bf78510aed47df4464bcbf8',
        assignedTo: 'Sameer Herkal',
        incidentStatus: 'Resolved',
        resourceName: 'Lenovo007',
        resourcePoolName: 'Password Reset Pool',
        recentCurrentActiveProcess: 'Password Reset Process',
        timeSpaceSinceRecentExecution: '02:05',
        numberOfSimilarIssues: 9,
        lastStatusChanged: '1/12/2022 8:31:31 AM',
        client: 'CIBC',
        resourceStatus: 'available'
    }],
    busy: [{
        incidentNo: 'INC1856382',
        incidentUrl: 'https://ibmgbsindia1prod.service-now.com/incident.do?sys_id=34b05ce01bf78510aed47df4464bcbf8',
        incidentStatus: 'New',
        resourceName: 'Lenovo001',
        resourcePoolName: 'Order to Cash Pool',
        recentCurrentActiveProcess: 'Order to Cash Process',
        timeSpaceSinceRecentExecution: '00:30',
        numberOfSimilarIssues: 14,
        lastStatusChanged: '1/12/2022 8:31:31 AM',
        client: 'CIBC',
        resourceStatus: 'busy'
    },
    {
        incidentNo: 'INC1857812',
        incidentUrl: 'https://ibmgbsindia1prod.service-now.com/incident.do?sys_id=34b05ce01bf78510aed47df4464bcbf8',
        assignedTo: 'Sameer Herkal',
        incidentStatus: 'On Hold',
        resourceName: 'Lenovo007',
        resourcePoolName: 'Password Reset Pool',
        recentCurrentActiveProcess: 'Password Reset Process',
        timeSpaceSinceRecentExecution: '02:05',
        numberOfSimilarIssues: 9,
        lastStatusChanged: '1/12/2022 8:31:31 AM',
        client: 'CIBC',
        resourceStatus: 'busy'
    }
    ],
    private: [{
        incidentNo: 'INC1856382',
        incidentUrl: 'https://ibmgbsindia1prod.service-now.com/incident.do?sys_id=34b05ce01bf78510aed47df4464bcbf8',
        incidentStatus: 'New',
        resourceName: 'Lenovo001',
        resourcePoolName: 'Order to Cash Pool',
        recentCurrentActiveProcess: 'Order to Cash Process',
        timeSpaceSinceRecentExecution: '00:30',
        numberOfSimilarIssues: 14,
        lastStatusChanged: '1/12/2022 8:31:31 AM',
        client: 'CIBC',
        resourceStatus: 'private'
    },
    {
        incidentNo: 'INC1857812',
        incidentUrl: 'https://ibmgbsindia1prod.service-now.com/incident.do?sys_id=34b05ce01bf78510aed47df4464bcbf8',
        assignedTo: 'Sameer Herkal',
        incidentStatus: 'New',
        resourceName: 'Lenovo007',
        resourcePoolName: 'Password Reset Pool',
        recentCurrentActiveProcess: 'Password Reset Process',
        timeSpaceSinceRecentExecution: '02:05',
        numberOfSimilarIssues: 9,
        lastStatusChanged: '1/12/2022 8:31:31 AM',
        client: 'CIBC',
        resourceStatus: 'private'
    }]
}